import React from "react"
import tw, { styled } from "twin.macro"

const LinkIcon = styled.a`
  ${tw`p-1 block`}

  & g.hover {
    opacity: 0;
    transition: all 200ms;
  }

  &:hover g.hover {
    opacity: 1;
    transition: all 200ms;
  }
`

const LinkedinIcon = ({ ...rest }) => (
  <LinkIcon {...rest} rel="noopener noreferrer" target="_blank">
    <svg
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#737373">
        <path d="m12.5 25c-6.90355937 0-12.5-5.5964406-12.5-12.5 0-6.90355937 5.59644063-12.5 12.5-12.5 6.9035594 0 12.5 5.59644063 12.5 12.5 0 6.9035594-5.5964406 12.5-12.5 12.5zm0-24.3902439c-6.56680038 0-11.8902439 5.32344352-11.8902439 11.8902439 0 6.5668004 5.32344352 11.8902439 11.8902439 11.8902439 6.5668004 0 11.8902439-5.3234435 11.8902439-11.8902439 0-6.56680038-5.3234435-11.8902439-11.8902439-11.8902439z" />
        <path d="m9.00000522 18h-3v-8h3zm-1.5070396-9.00414495h-.01760561c-.38154979.03098652-.75767015-.11279354-1.03773396-.396696-.28006381-.28390247-.4386749-.6821831-.43762083-1.09887521 0-.85132515.59507465-1.49557121 1.510566-1.49557121.38336579-.03312253.76203811.10944302 1.04477537.3933453.28273727.28390228.44390102.6833972.44465863 1.10222591 0 .83598596-.58098489 1.49557121-1.5070396 1.49557121zm11.50703958 9.00414495h-3.0264817v-4.1077263c0-1.0596026-.4691047-1.8083885-1.5132409-1.8083885-.6535785-.0000502-1.2333355.3916635-1.4375788.9713024-.0632678.2100244-.0850605.4290466-.0643127.6463577v4.2984547h-2.9583859s.037831-7.2759382 0-7.9364238h2.9810845v1.2573951c.1778058-.5439294 1.1349307-1.3209713 2.6481715-1.3209713 1.8915511 0 3.370744 1.1408389 3.370744 3.599117z" />
      </g>

      <g className="hover">
        <path
          d="m12.5 25c-6.90355937 0-12.5-5.5964406-12.5-12.5 0-6.90355937 5.59644063-12.5 12.5-12.5 6.9035594 0 12.5 5.59644063 12.5 12.5 0 6.9035594-5.5964406 12.5-12.5 12.5z"
          fill="#0274b3"
        />
        <path
          d="m9.00000522 18h-3v-8h3zm-1.5070396-9.00414495h-.01760561c-.38154979.03098652-.75767015-.11279354-1.03773396-.396696-.28006381-.28390247-.4386749-.6821831-.43762083-1.09887521 0-.85132515.59507465-1.49557121 1.510566-1.49557121.38336579-.03312253.76203811.10944302 1.04477537.3933453.28273727.28390228.44390102.6833972.44465863 1.10222591 0 .83598596-.58098489 1.49557121-1.5070396 1.49557121zm11.50703958 9.00414495h-3.0264817v-4.1077263c0-1.0596026-.4691047-1.8083885-1.5132409-1.8083885-.6535785-.0000502-1.2333355.3916635-1.4375788.9713024-.0632678.2100244-.0850605.4290466-.0643127.6463577v4.2984547h-2.9583859s.037831-7.2759382 0-7.9364238h2.9810845v1.2573951c.1778058-.5439294 1.1349307-1.3209713 2.6481715-1.3209713 1.8915511 0 3.370744 1.1408389 3.370744 3.599117z"
          fill="#fff"
        />
      </g>
    </svg>
  </LinkIcon>
)

const TwitterIcon = ({ ...rest }) => (
  <LinkIcon {...rest} rel="noopener noreferrer" target="_blank">
    <svg
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#737373">
        <path d="m12.5 25c-6.90355937 0-12.5-5.5964406-12.5-12.5 0-6.90355937 5.59644063-12.5 12.5-12.5 6.9035594 0 12.5 5.59644063 12.5 12.5 0 6.9035594-5.5964406 12.5-12.5 12.5zm0-24.3902439c-6.56680038 0-11.8902439 5.32344352-11.8902439 11.8902439 0 6.5668004 5.32344352 11.8902439 11.8902439 11.8902439 6.5668004 0 11.8902439-5.3234435 11.8902439-11.8902439 0-6.56680038-5.3234435-11.8902439-11.8902439-11.8902439z" />
        <path d="m19.4207317 8.76364244c-.4930649.21789198-1.0159037.36093279-1.5512195.42439025.563452-.33690625.9848535-.86755994 1.1853658-1.49268293-.5302669.314863-1.1106445.53637173-1.7158536.65487805-.7590753-.80607736-1.93292-1.06785378-2.962561-.66067392-1.0296409.40717987-1.7069464 1.40100863-1.7093902 2.50823491-.0007792.2068824.0225489.4131511.0695122.6146341-2.172926-.1088986-4.19780078-1.13396656-5.57195125-2.82073168-.7154213 1.23527281-.34880725 2.81379448.83780487 3.60731708-.42945739-.0133503-.84957015-.1287246-1.22560975-.3365854v.0329269c.00075614 1.2866844.9081881 2.3945777 2.16951219 2.6487804-.23233272.0641988-.47237771.0962048-.71341463.095122-.17430688.0011145-.34830522-.0148149-.5195122-.047561.35251122 1.1017988 1.36775042 1.856607 2.52439027 1.8768293-1.13092633.8818764-2.56314316 1.2839483-3.9878049 1.1195122 1.23538476.7937834 2.67304012 1.2154279 4.1414634 1.2146353 4.9719512 0 7.6829268-4.1158548 7.6829268-7.682928 0-.1170732 0-.2341463 0-.3658537.5275951-.37999801.9834628-.85073101 1.3463415-1.39024386" />
      </g>
      <g className="hover">
        <path
          d="m12.5 25c-6.90355937 0-12.5-5.5964406-12.5-12.5 0-6.90355937 5.59644063-12.5 12.5-12.5 6.9035594 0 12.5 5.59644063 12.5 12.5 0 6.9035594-5.5964406 12.5-12.5 12.5z"
          fill="#1da1f2"
        />
        <path
          d="m19.4207317 8.76364244c-.4930649.21789198-1.0159037.36093279-1.5512195.42439025.563452-.33690625.9848535-.86755994 1.1853658-1.49268293-.5302669.314863-1.1106445.53637173-1.7158536.65487805-.7590753-.80607736-1.93292-1.06785378-2.962561-.66067392-1.0296409.40717987-1.7069464 1.40100863-1.7093902 2.50823491-.0007792.2068824.0225489.4131511.0695122.6146341-2.172926-.1088986-4.19780078-1.13396656-5.57195125-2.82073168-.7154213 1.23527281-.34880725 2.81379448.83780487 3.60731708-.42945739-.0133503-.84957015-.1287246-1.22560975-.3365854v.0329269c.00075614 1.2866844.9081881 2.3945777 2.16951219 2.6487804-.23233272.0641988-.47237771.0962048-.71341463.095122-.17430688.0011145-.34830522-.0148149-.5195122-.047561.35251122 1.1017988 1.36775042 1.856607 2.52439027 1.8768293-1.13092633.8818764-2.56314316 1.2839483-3.9878049 1.1195122 1.23538476.7937834 2.67304012 1.2154279 4.1414634 1.2146353 4.9719512 0 7.6829268-4.1158548 7.6829268-7.682928 0-.1170732 0-.2341463 0-.3658537.5275951-.37999801.9834628-.85073101 1.3463415-1.39024386"
          fill="#fff"
        />
      </g>
    </svg>
  </LinkIcon>
)

const FacebookIcon = ({ ...rest }) => (
  <LinkIcon {...rest} rel="noopener noreferrer" target="_blank">
    <svg viewBox="0 0 25 25" width="25" height="25">
      <g fill="#737373" fillRule="nonzero">
        <path d="m12.5 25c-6.904 0-12.5-5.596-12.5-12.5s5.596-12.5 12.5-12.5 12.5 5.596 12.5 12.5-5.596 12.5-12.5 12.5zm0-24.39c-6.567 0-11.89 5.323-11.89 11.89s5.323 11.89 11.89 11.89 11.89-5.323 11.89-11.89-5.323-11.89-11.89-11.89z" />
        <path
          d="m17.05 23.5v-6.85h2.3l.35-2.65h-2.65v-1.7c0-.75.2-1.3 1.3-1.3h1.4v-2.4c-.25-.05-1.1-.1-2.05-.1-2.05 0-3.45 1.25-3.45 3.5v2h-2.25v2.65h2.3v6.85z"
          transform="matrix(.929639 0 0 .929639 -2.25802 -2.37422)"
        />
      </g>
      <g fillRule="nonzero" className="hover">
        <path
          d="m12.5 25c-6.904 0-12.5-5.596-12.5-12.5s5.596-12.5 12.5-12.5 12.5 5.596 12.5 12.5-5.596 12.5-12.5 12.5z"
          fill="#3b5998"
        />
        <path
          d="m17.05 23.5v-6.85h2.3l.35-2.65h-2.65v-1.7c0-.75.2-1.3 1.3-1.3h1.4v-2.4c-.25-.05-1.1-.1-2.05-.1-2.05 0-3.45 1.25-3.45 3.5v2h-2.25v2.65h2.3v6.85z"
          fill="#fff"
          transform="matrix(.929639 0 0 .929639 -2.25802 -2.37422)"
        />
      </g>
    </svg>
  </LinkIcon>
)

const ShareButtons = ({ url, title }) => {
  const linkedinUrl = (url) =>
    `https://www.linkedin.com/sharing/share-offsite/?url=${url}`

  const twitterUrl = (url, title) =>
    `http://www.twitter.com/share?text=${title}&url=${url}&via=ParrotAnalytics`

  const facebookUrl = (url, title) =>
    `https://www.facebook.com/sharer.php?u=${url}`

  function socialWindow(url) {
    var left = (window.screen.width - 570) / 2
    var top = (window.screen.height - 650) / 2
    var params =
      "menubar=no,toolbar=no,status=no,width=570,height=650,top=" +
      top +
      ",left=" +
      left
    window.open(url, "SocialShareWindow", params)
  }

  return (
    <div className="flex flex-row justify-center pb-4 h-12 mx-auto">
      <LinkedinIcon
        title="Share on LinkedIn"
        href={linkedinUrl(url)}
        onClick={(e) => {
          e.preventDefault()
          socialWindow(linkedinUrl(url))
        }}
      />
      <TwitterIcon
        title="Share on Twitter"
        href={twitterUrl(url, title)}
        onClick={(e) => {
          e.preventDefault()
          socialWindow(twitterUrl(url, title))
        }}
      />
      <FacebookIcon
        title="Share on Facebook"
        href={facebookUrl(url)}
        onClick={(e) => {
          e.preventDefault()
          socialWindow(facebookUrl(url))
        }}
      />
    </div>
  )
}

export default ShareButtons
